@if (productId) {
    <app-add-sub-product-form [productId]="productId"></app-add-sub-product-form>
}